import React from 'react'

import CompetitiveIntelligenceHeader from 'components/CompetitiveIntelligence/Header'
import ResearchDetail from 'components/CompetitiveIntelligence/ResearchDetail'
import ResearchDetailSkeleton from 'components/CompetitiveIntelligence/ResearchDetailSkeleton'
import CompetitiveIntelligenceState from 'components/CompetitiveIntelligence/State'
import useController from './controller'
import { Page } from './styled'

const STATE_COPY = {
    denied: ['competitive_intelligence_denied_title', 'competitive_intelligence_denied_description'],
    error: ['competitive_intelligence_research_error_title', 'competitive_intelligence_research_error_description'],
    notFound: ['competitive_intelligence_research_not_found_title', 'competitive_intelligence_research_not_found_description'],
    unavailable: ['competitive_intelligence_unavailable_title', 'competitive_intelligence_unavailable_description'],
}

export default function CompetitiveIntelligenceResearchDetail() {
    const controller = useController()
    return (
        <Page>
            <CompetitiveIntelligenceHeader
                description={controller.t('competitive_intelligence_research_description')}
                eyebrow={controller.t('competitive_intelligence_title')}
                t={controller.t}
                title={controller.t('competitive_intelligence_nav_research')}
            />
            {controller.status === 'loading' ? (
                <ResearchDetailSkeleton label={controller.t('competitive_intelligence_research_detail_loading')} />
            ) : controller.status === 'ready' ? (
                <ResearchDetail {...controller} />
            ) : STATE_COPY[controller.status] ? (
                <CompetitiveIntelligenceState
                    actionLabel={controller.status === 'notFound' ? controller.t('competitive_intelligence_nav_research') : controller.t('try_again')}
                    description={controller.t(STATE_COPY[controller.status][1])}
                    onAction={controller.status === 'notFound' ? controller.onBack : ['error', 'unavailable'].includes(controller.status) ? controller.retry : undefined}
                    title={controller.t(STATE_COPY[controller.status][0])}
                    urgent
                />
            ) : null}
        </Page>
    )
}
